/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var VirtualAssistantSendIcon = createIcon("VirtualAssistantSendIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#2071C5';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "22",
    viewBox: "0 0 24 22"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M23 11a.752.752 0 00-.444-.685L2.439.692a1.02 1.02 0 00-.46-.088 1.03 1.03 0 00-.979 1c-.001.118.017.23.052.335L3.17 8.53c.183.57.69.975 1.288 1.03l7.633.692a.753.753 0 010 1.498l-7.633.693a1.494 1.494 0 00-1.288 1.029l-2.12 6.59a1.017 1.017 0 00-.05.334c.006.531.445.98.978 1.001.164.007.32-.025.46-.088l20.117-9.623A.752.752 0 0023 11Z",
    stroke: _color,
    fill: "none",
    fillRule: "evenodd"
  }));
}, {
  "replaceColor": true
});